export function MessengerGenericTemplateAManoBoxViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;

  return joint.shapes.html.AbstractBoxElementView.extend({

    template: [
      '<div class="html-element">',
        '<div class="carousel-container">',
          '<div class="carousel-invalid-message invalid-message ng-hide">',
            services.$translate.instant('parameters/quick_replies/details/graph/carousel-invalid-message'),
          '</div>',
          '<div class="carousel-header">',
            '<span class="glyphicon glyphicon-chevron-left previous-carousel-item"></span>',
            '<span class="carousel-page-number"></span>',
            '<span class="glyphicon glyphicon-chevron-right next-carousel-item"></span>',
            '<span class="glyphicon glyphicon-plus add-carousel-item"></span>',
          '</div>',
          '<div class="carousel-item">',
            '<div class="carousel-image"></div>',
            '<div class="generic-template-text-content">',
              '<div class="carousel-title"></div>',
              '<div class="carousel-subtitle"></div>',
              '<div class="item-edit-container"><span class="glyphicon glyphicon-pencil item-edit"></span></div>',
            '</div>',
          '</div>',
        '</div>',
      '</div>'
    ].join(''),


    displayedPageIndex: 0,


    initialize: function() {
      joint.shapes.html.AbstractBoxElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('.item-edit').on('click', () => this.editGenericTemplate());
      this.$box.find('.add-carousel-item').on('click', () => this.addCarouselItem());
      this.$box.find('.previous-carousel-item').on('click', () => this.previousCarouselItem());
      this.$box.find('.next-carousel-item').on('click', () => this.nextCarouselItem());
    },


    /**
     * Adds a new carousel element (if the maximum number hasn't been reached yet).
     * The new element is inserted just after the currently displayed item.
     * The displayed page index is increased and the item edition popin is opened
     * so that the user can directly edit the newly created item
     */
    addCarouselItem: function() {      
      const elements = this.model.get('elements');
      let maxElementId = 0;
      for (let element of elements) {
        if (maxElementId < element.carouselElementId) {
          maxElementId = element.carouselElementId;
        }
      }
      if (elements.length < 10) {
        const newElement = {
          title: services.$translate.instant('parameters/quick_replies/details/edit_generic_template_a_mano/title_label'),
          subtitle: services.$translate.instant('parameters/quick_replies/details/edit_generic_template_a_mano/subtitle_label'),
          carouselElementId: maxElementId + 1,
        };
        this.displayedPageIndex++;
        elements.splice(this.displayedPageIndex, 0, newElement);
        this.updateValidity();
        this.resizeBox();
        this.setGenericTemplateHtmlContent();
        this.updateButtonGroupsAfterElementsUpdate();
        this.editGenericTemplate();
      }
    },

    /**
     * Removes the currently displayed carousel item
     * (if it is not the last item).
     */
    removeCarouselItem: function() {      
      const elements = this.model.get('elements');
      if (elements.length > 1) {
        elements.splice(this.displayedPageIndex, 1);
      }
    },


    /**
     * Switches the currently displayed page to the previous page,
     * if not currently displaying the first page
     */
    previousCarouselItem: function() {
      if (this.displayedPageIndex > 0) {
        this.displayedPageIndex--;
        this.setGenericTemplateHtmlContent();
        this.resizeBox();
      }
    },


    /**
     * Switches the currently displayed page to the next page,
     * if not currently displaying the last page
     */
    nextCarouselItem: function() {
      if (this.displayedPageIndex < this.model.get('elements').length - 1) {
        this.displayedPageIndex++;
        this.setGenericTemplateHtmlContent();
        this.resizeBox();
      }
    },


    /**
     * Adds/removes a button group after adding/removing a carousel element
     */
    updateButtonGroupsAfterElementsUpdate: function() {
      // let's reference the box's children before they are unembeded
      const childrenBeforeUpdate = this.model.getEmbeddedCells(); 
      this.unembedOrRemoveChildren();
      this.reembedChildren(childrenBeforeUpdate);
      this.updateHeaderGroupsIndexes();
      this.enableOrDisableAddButtons();
      this.resizeBox();
      if (this.displayedPageIndex >= this.model.get('elements').length) {
        this.displayedPageIndex = this.model.get('elements').length -1;
      }
    },


    /*
     * When the carousel elements have been updated, 
     * all children (buttons, group headers and 'add button' items)
     * need to either be unembeded to be sorted acording to their corresponding carousel element,
     * or removed completely if their corresponding carousel element has been removed
     */
    unembedOrRemoveChildren: function() {
      for (let child of this.model.getEmbeddedCells()) {
        let carouselElementId = this.childsCarouselElementId(child);
        if (this.hasElementWithGivenCarouselElementId(carouselElementId)) {
          this.model.unembed(child);
        } else {
          child.remove(); // this will remove any outgoing links too
        }
      }      
    },

    /**
     * Returns the id of the carousel element to which this child belongs
     * If the given child is a button or a button group header, 
     * that id is stored in its 'carouselElementId' model property;
     * if it is an 'add button' child, the id is stored in its addChildId property.
     */
    childsCarouselElementId(child) {
      return child.get('carouselElementId') !== undefined 
              ? child.get('carouselElementId') 
                : child.get('addChildId')
    },


    /*
     * For each carousel element in the model,
     * if we can find buttons (and a header and a 'add a button' item)
     * that have a matching carouselElementId, 
     * we embed them; otherwise we embed a new header and 'add a button' item.
     */
    reembedChildren: function(childrenBeforeUpdate) {
      for (let element of this.model.get('elements')) {
        const currentElementId = element.carouselElementId;
        let foundChildren = false;
        for (let child of childrenBeforeUpdate) {
          if (this.childsCarouselElementId(child) === currentElementId) {
            this.model.embed(child);
            foundChildren = true;
          } 
        }
        if (!foundChildren) {
          this.embedNewButtonGroupHeaderAndAddButton(currentElementId);
        }
      }
    },


    /**
     * Adds a button group header and an 'add button' button to this box,
     * qssigning them the given carousel element id.
     */
    embedNewButtonGroupHeaderAndAddButton: function(carouselElementId) {
      const actionGroupHeader = new joint.shapes.html.MessengerButtonGroupHeader({
        carouselElementId: carouselElementId
      });
      const addButton = new joint.shapes.html.MessengerAddButton({
        addChildId: carouselElementId
      });
      this.model.embed(actionGroupHeader);
      this.model.graph.addCell(actionGroupHeader);
      this.model.embed(addButton);
      this.model.graph.addCell(addButton);
    },


    /**
     * Tells whether our model contains a carousel element
     * that has the given id
     */
    hasElementWithGivenCarouselElementId: function(id) {
      let result = false;
      this.model.get('elements').forEach(element => {
        if (element.carouselElementId === id) {
          result = true;
        }
      });
      return result;
    },


    /**
     * Updates the text to be displayed by button group headers
     * with the index of their 'owner' carousel element and total number of groups.
     * Needs to be called after inserting or removing a carousel element.
     */
    updateHeaderGroupsIndexes: function() {
      const totalGroupsNumber = this.model.get('elements').length;
      let i = 1;
      for (let child of this.model.getEmbeddedCells()) {
        if (child.get('type') === 'html.MessengerButtonGroupHeader') {
          child.set('groupIndex', i++);
          child.set('totalGroupsNumber', totalGroupsNumber);
        }
      }
    },


    /**
     * Adds a new button within an exisiting button group
     * We loop on all children and we unembed all children
     * starting from the 'add button' item that has the given carouselElementId,
     * then we insert a new button,
     * then we re-embed all unembeded children.
     */
    addChildClicked: function(buttonId, carouselElementId) {
      let unembeded = [];
      let unembedding = false;
      for (let child of this.model.getEmbeddedCells()) {
        if (   child.get('addChildId') === carouselElementId
            && child.get('type') === 'html.MessengerAddButton') {

          unembedding = true;
        }
        if (unembedding) {
          this.model.unembed(child);
          unembeded.push(child);
        }
      }
      const button = new joint.shapes.html.MessengerButton({
        id: buttonId,
        carouselElementId: carouselElementId,
        button: this.newButtonData()
      });
      this.model.embed(button);
      this.model.graph.addCell(button);
      unembeded.forEach(child => this.model.embed(child));
      this.enableOrDisableAddButtons();
      this.resizeBox();
      this.paper.findViewByModel(button).editButton();
    },


    /**
     * Button data structure that will be used when a button is newly created
     */
    newButtonData: function() {
      return {
        title: services.$translate.instant('parameters/quick_replies/details/graph/new_button_label'),
        type: 'postback'
      }
    },


    /*
     * cf https://developers.facebook.com/docs/messenger-platform/reference/template/generic/ :
     * each carousel item can have at most 3 buttons.
     * This function updates the 'add button' buttons accordingly.
     */
    enableOrDisableAddButtons: function() {
      let buttonsNumber = 0;
      for (let child of this.model.getEmbeddedCells()) {
        switch (child.get('type')) {
          case 'html.MessengerButtonGroupHeader':
            buttonsNumber = 0;
            break;
          case 'html.MessengerButton':
            buttonsNumber++; 
            break;
          case 'html.MessengerAddButton':
            child.set('disabled', buttonsNumber >= 3);
            break;
          default:
            break;
        }
      }
    },

    /**
     * Event handler that shows a modal for editing the generic template 
     */
    editGenericTemplate : function() {
      const elements = this.model.get('elements');
      let editedElement = elements[this.displayedPageIndex];
      const modalTitle = services.$translate.instant('parameters/quick_replies/details/edit_generic_template_a_mano/title')
                       + ' ' + this.pageIndexAndTotalPagesAsText();
      let modalInstance = services.$uibModal.open({
        animation: true,
        template:  require('../../shared/editTemplateElement.modal.html'),
        controller: 'editTemplateElementController',
          resolve: {
            companyId: () => companyId,
            siteId: () => siteId,
            templateType: () => this.model.get('type'),
            element: () => angular.copy(editedElement),
            modalTitle: () => modalTitle,
            showRemoveButton: elements.length > 1,
            showCompactCheckbox: false
          }
      });
      // Hook callback that will update the model and save the updated graph
      modalInstance.result.then(result => {  
        if (result.type === 'edit') {
          this.model.get('elements')[this.displayedPageIndex] = result.element;
        } else if (result.type === 'delete') {
          this.removeCarouselItem();
        }
        callbacks.updateSerializedGraph(this.model.graph);
        this.updateButtonGroupsAfterElementsUpdate();
        this.updateValidity();
        this.setGenericTemplateHtmlContent();
        this.resizeBox();
        this.updateBox();
      });
    },

    pageIndexAndTotalPagesAsText: function() {
      return (this.displayedPageIndex + 1) + '/' + this.model.get('elements').length;
    },

    /** 
     * All carousel elements need to have an image
     * (they also need to have a valid URL, but this enforced by the button edition popin)
     * Caller is responsible to call resizeBox too, if necessary
     */
    updateValidity: function() {
      let valid = true;
      const elements = this.model.get('elements');
      if (this.model.isLinkTarget() && elements) { // only report validity errors for connected boxes
        elements.forEach(element => valid = valid && typeof element.pictureId === 'number');
      }
      this.model.setBoxValid(valid);
      if (valid) {
        this.$box.find('.carousel-invalid-message').addClass('ng-hide');
      } else {
        this.$box.find('.carousel-invalid-message').removeClass('ng-hide');
      }
    },


    setGenericTemplateHtmlContent: function() {
      const element = this.model.get('elements')[this.displayedPageIndex];
      let bgImage;
      if (typeof element.pictureId === 'number') {
        services.MediasFactory.pictureUrlWithJWT(companyId, element.pictureId).then((urlWithJwt) => {
          bgImage = `url("${urlWithJwt}")`;
          this.$box.find('.carousel-image').css('background-image',  bgImage);
        });

      } else {
        bgImage = 'none';
        this.$box.find('.carousel-image').css('background-image',  bgImage);
      }
      this.$box.find('.carousel-page-number').text(this.pageIndexAndTotalPagesAsText());
      this.$box.find('.carousel-title').text(element.title);
      this.$box.find('.carousel-subtitle').text(element.subtitle);
    },


    afterDeserialize: function(shouldResize) {
      this.setGenericTemplateHtmlContent();
      this.updateHeaderGroupsIndexes();
      this.enableOrDisableAddButtons();
      if (shouldResize) {
        this.resizeBox();
      }
    },


    resizeBox: function() {
      if (services.JointjsOptimisationsFactory.logCallsToResize()) {
        console.warn('MessengerGenericTemplateAManoBoxView - resizeBox()');
      }
      let box = this.model;
      let embeddedCells = box.getEmbeddedCells();
      let paddingTop = this.$box.find('.carousel-container').outerHeight();

      //Reposition and resize every item
      let ypos = paddingTop ;
      for (let child of embeddedCells) {
        let childView = this.paper.findViewByModel(child);
        child.position(0, ypos, {parentRelative: true});
        let childHeight = childView.$box.outerHeight();
        child.resize(box.attributes.size.width, childHeight);
        ypos += childHeight;
      }

      box.fitEmbeds({padding: {top: paddingTop, right: 0, bottom: 0, left: 0}});
      callbacks.resizePaper();
    }
  });
}